const DroneSvg = props => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1258 1136" {...props}>
    <path
      fill="#6B80D2"
      stroke="#101010"
      strokeWidth={0.5}
      d="m334.455 275.271-.008 1.892-.775 1.845.008-1.893.775-1.844Z"
    />
    <path fill="#101010" d="m323.592 275.642-.012 3.195 1.565 1.722v-3.195l-1.553-1.722Z" />
    <path
      fill="#6B80D2"
      stroke="#101010"
      strokeWidth={0.5}
      d="m333.179 277.434-.011 2.657-2.256.909.01-2.667 2.257-.899Zm-2.757 1.963v1.911l-7.581 17.915-.001.001c-.148.356-.549.68-1.139.887a4.371 4.371 0 0 1-2.035.172 3.523 3.523 0 0 1-1.24-.406l-.003-.001c-.486-.273-.704-.627-.704-.955v-2.154c.135.128.293.245.468.347l.126-.216m12.109-17.501-7.109 16.825-.23-.097m7.339-16.728-7.108 16.824m7.108-16.824-7.108 16.824m-5.001.677c.361.213.808.362 1.33.437 1.527.213 3.068-.324 3.44-1.21m-4.77.773a2.052 2.052 0 0 1-.594-.502l.594.502Zm4.77-.773.231.096m-.231-.096.231.096"
    />
    <path
      fill="#F1F5F9"
      stroke="#101010"
      d="m330.487 277.699-.194.077-.081.192-7.602 17.962v.001c-.108.256-.431.542-.992.739a4.184 4.184 0 0 1-1.918.17c-.47-.067-.852-.199-1.145-.372l-.002-.001c-.284-.166-.453-.349-.533-.508a.49.49 0 0 1-.016-.438l7.602-17.962.124-.293-.214-.237-1.339-1.486 1.081-2.548 4.123-1.447 2.402.346 2.332 2.246-1.076 2.538-2.552 1.021Z"
    />
    <path
      fill="#6B80D2"
      stroke="#101010"
      strokeWidth={0.5}
      d="m380.403 301.399-.01 2.496-2.168 2.108.009-2.495 2.169-2.109Zm-2.669 2.292-.011 2.69-4.718.688v-2.69l4.729-.688Zm-5.229 3.331-2.48-.748.01-2.673 2.47.748v2.673Z"
    />
    <path
      fill="#101010"
      d="M335.417 306.123v3.195c0 .137.025.275.075.412.137.3.397.562.745.774.683.399 1.702.587 2.708.437l30.829-4.481v-3.196l-34.357 2.859Z"
    />
    <path
      fill="#F1F5F9"
      stroke="#101010"
      d="m375.451 298.185 4.142 1.445.455 1.057-2.308 2.243-4.959.722-2.862-.866-.106-.032-.111.016-30.829 4.481h-.002c-.911.136-1.811-.041-2.381-.374l-.004-.002c-.292-.168-.462-.355-.53-.525l-.002-.007-.004-.008c-.09-.207-.058-.439.205-.695.276-.27.778-.518 1.471-.62h.001l30.828-4.481.143-.021.11-.094 1.778-1.516 4.965-.723Z"
    />
    <path
      fill="#101010"
      d="m346.087 306.884-5.266 7.839 1.192-.737a3.624 3.624 0 0 0 1.292-1.31l3.577-5.904-.807.112h.012Z"
    />
    <path
      fill="#6B80D2"
      d="M311.469 289.634s.187 10.647 3.64 12.644l20.569 11.933c2.72 1.573 5.205 1.273 6.459-.799l3.963-6.54-34.134-17.887-.497.624v.025Z"
    />
    <path fill="#101000" d="m339.703 313.874-.683.4v-1.998l.683-.387v1.985Z" />
    <path fill="#27221E" d="m330.834 309.53 8.186 4.744v-1.998l-7.279-4.219-.907 1.473Z" />
    <path fill="#38302D" d="m332.424 307.658-.683.399 7.279 4.219.683-.387-7.279-4.231Z" />
    <path
      fill="#38302D"
      d="M340.895 311.44c-.484-.287-.931-.312-1.242-.112l-.82.474 2.497 4.294.82-.474c.31-.188.497-.575.497-1.136 0-1.124-.783-2.484-1.752-3.046Z"
    />
    <path
      fill="#27221E"
      d="M340.075 311.914c.969.562 1.752 1.923 1.752 3.046 0 1.123-.783 1.573-1.752 1.011s-1.751-1.922-1.751-3.046c0-1.123.782-1.572 1.751-1.011Z"
    />
    <path
      fill="#38302D"
      d="M337.815 310.442c-.398-.238-1.292.049-2.174.561-1.192.687-2.385 1.81-2.385 2.646l2.683 1.76 1.019.412 4.558-3.208-3.714-2.171h.013Z"
    />
    <path
      fill="#101010"
      d="m337.206 315.971-3.95-2.309v3.495c0 .212.075.362.224.437l3.714 2.172.024-3.795h-.012Z"
    />
    <path
      fill="#27221E"
      d="M341.74 313.05c0-.836-1.193-.561-2.385.125-1.193.687-2.385 1.81-2.385 2.646v3.495c0 .837 1.192.562 2.385-.125 1.192-.686 2.385-1.809 2.385-2.646v-3.495Z"
    />
    <path
      fill="url(#a)"
      d="m341.814 314.161-.832-.487c-.385-.212-.907-.174-1.49.163-1.168.674-2.125 2.334-2.125 3.694 0 .687.249 1.174.634 1.386l.832.487 2.969-5.243h.012Z"
    />
    <path
      fill="#27221E"
      d="M338.2 318.018c0-1.36.956-3.021 2.124-3.695 1.167-.674 2.124-.124 2.124 1.236 0 1.361-.957 3.021-2.124 3.695-1.168.674-2.124.125-2.124-1.236Z"
    />
    <path
      fill="url(#b)"
      d="M340.411 315.31c-.721.411-1.292 1.422-1.292 2.246 0 .824.584 1.161 1.292.749.72-.412 1.291-1.423 1.291-2.247 0-.823-.583-1.16-1.291-.748Z"
      style={{
        mixBlendMode: 'multiply'
      }}
    />
    <path
      fill="url(#c)"
      d="M340.361 314.673c1.006-.587 1.813-.112 1.813 1.048 0 1.161-.807 2.572-1.813 3.158-1.006.587-1.814.113-1.814-1.048s.808-2.571 1.814-3.158Z"
      opacity={0.4}
    />
    <path
      fill="url(#d)"
      d="m338.659 317.07 2.286 1.323c.422-.425.782-.974.993-1.548l-2.434-1.411a4.28 4.28 0 0 0-.845 1.636Z"
      opacity={0.4}
    />
    <path
      fill="url(#e)"
      d="M339.864 316.133a.676.676 0 0 0-.31.537c0 .2.136.275.31.175a.677.677 0 0 0 .311-.537c0-.2-.137-.275-.311-.175Z"
      opacity={0.7}
      style={{
        mixBlendMode: 'screen'
      }}
    />
    <path fill="#101000" d="m333.765 317.319-.683.4v-1.998l.683-.399v1.997Z" />
    <path fill="#27221E" d="m324.909 312.963 8.173 4.756v-1.998l-7.279-4.218-.894 1.46Z" />
    <path fill="#38302D" d="m326.487 311.103-.684.4 7.279 4.218.683-.399-7.278-4.219Z" />
    <path
      fill="#38302D"
      d="M334.97 314.873c-.484-.287-.931-.312-1.242-.113l-.82.475 2.497 4.293.82-.474c.31-.187.497-.574.497-1.136 0-1.123-.783-2.484-1.752-3.045Z"
    />
    <path
      fill="#101010"
      d="M334.138 315.359c.969.562 1.751 1.923 1.751 3.046 0 1.123-.782 1.573-1.751 1.011-.969-.562-1.751-1.922-1.751-3.045 0-1.124.782-1.573 1.751-1.012Z"
    />
    <path
      fill="#101010"
      d="m336.622 312.389-5.266 7.838 1.192-.736a3.62 3.62 0 0 0 1.292-1.311l3.577-5.904-.807.113h.012Z"
    />
    <path
      fill="#6B80D2"
      stroke="#101010"
      d="m335.919 312.56-3.687 6.085c-.549.908-1.35 1.411-2.313 1.529-.979.121-2.171-.154-3.467-.903l9.467-6.711Zm0 0-33.296-17.448-.127.159.01.296c.012.291.033.71.068 1.219.071 1.02.2 2.397.436 3.832.237 1.439.577 2.919 1.061 4.151.492 1.251 1.099 2.157 1.811 2.569l20.569 11.932 9.468-6.71Z"
    />
    <path
      fill="#101010"
      d="M301.607 293.291v1.286c0 .287.124.512.435.686 2.794 1.623 28.991 16.814 31.823 18.461 2.67 1.548 13.452-4.431 13.464-6.915v-1.285l-45.722-12.245v.012Z"
    />
    <path
      fill="#C88BC4"
      stroke="#101010"
      d="m346.13 304.381.046.032c.225.155.353.249.45.386.087.124.175.323.203.712-.006.155-.101.411-.372.774-.271.361-.673.768-1.184 1.199-1.02.863-2.421 1.779-3.915 2.576-1.493.796-3.057 1.461-4.397 1.83-.671.185-1.271.292-1.77.311-.507.018-.858-.057-1.075-.182-1.79-1.041-12.901-7.486-21.548-12.501a30285.1 30285.1 0 0 1-10.274-5.96.447.447 0 0 1-.158-.135.205.205 0 0 1-.029-.107c.016-.261.045-.656.399-1.229.374-.606 1.13-1.438 2.684-2.488 1.906-1.28 3.716-2.226 5.197-2.856 1.502-.639 2.614-.932 3.139-.953.269-.011.448.019.574.055.127.037.219.085.337.147 2.707 1.49 7.486 4.297 11.465 6.633a976.162 976.162 0 0 0 4.607 2.696l.001.001c.931.536 1.899 1.098 2.904 1.684l.004.002c.636.363 1.285.74 1.951 1.126l1.177.683h.001c5.18 2.984 8.096 4.679 9.583 5.564Z"
    />
    <path
      fill="#F7F5EB"
      stroke="#101010"
      d="m328.752 296.317 11.699 6.788a8.98 8.98 0 0 1-.333.256c-.634.464-1.595 1.073-2.607 1.664-1.012.591-2.058 1.154-2.858 1.527-.404.189-.727.32-.946.385a1.081 1.081 0 0 1-.09.025c-1.57-.914-10.396-6.033-17.279-10.025l-7.841-4.548c.092-.074.203-.16.334-.255.633-.464 1.594-1.074 2.607-1.665a37.715 37.715 0 0 1 2.858-1.527c.404-.188.727-.319.945-.385l.09-.024c3.031 1.755 7.805 4.525 13.421 7.784Z"
    />
    <path
      fill="#101010"
      d="m329.008 318.405-22.532-13.069a1.21 1.21 0 0 1-.584-.861l-.733-4.618c-.012-.088.075-.15.15-.1l25.972 15.066c.087.05.112.15.062.237l-1.975 3.27a.25.25 0 0 1-.348.088l-.012-.013Z"
    />
    <path
      fill="#101010"
      stroke="#101010"
      strokeWidth={0.5}
      d="m309.744 306.824-30.531 4.439v-2.692l32.108-5.046.358.208v1.741c0 .264-.154.551-.491.805-.335.253-.83.456-1.444.545Z"
    />
    <path fill="#101010" d="m266.704 307.608-.013 3.196.683 1.56v-3.208l-.67-1.548Z" />
    <path
      fill="#F1F5F9"
      stroke="#101010"
      strokeWidth={0.5}
      d="M278.713 308.899v2.538l-1.388 1.184v-2.538l1.388-1.184Z"
    />
    <path
      fill="#101010"
      stroke="#101010"
      strokeWidth={0.5}
      d="m271.596 313.572-3.972-1.386v-2.678l3.972 1.386v2.678Z"
    />
    <path
      fill="#6B80D2"
      stroke="#101010"
      strokeWidth={0.5}
      d="M276.825 310.256v2.69l-4.729.689v-2.702l4.729-.677Z"
    />
    <path
      fill="#F1F5F9"
      stroke="#101010"
      d="m307.111 301.359 3.235 1.881a3.879 3.879 0 0 1-.615.141l-.001.001-30.826 4.48-.143.021-.11.094-1.778 1.516-4.966.723-4.15-1.448-.456-1.043 2.305-2.242 4.959-.722 2.862.867.107.032.11-.016 29.467-4.285Z"
    />
    <path
      fill="#101010"
      d="m329.505 313.787-7.304 17.25v3.195l7.59-17.961c.049-.138.087-.262.087-.4v-1.872l-.373-.225v.013Zm-7.03 22.031-.013 3.195 1.292-3.046.012-3.195-1.291 3.046Zm-9.838-1.436v3.208l2.695 2.596.013-3.195-2.708-2.609Z"
    />
    <path
      fill="#6B80D2"
      stroke="#101010"
      strokeWidth={0.5}
      d="m317.754 340.285-2.171-.315.011-2.69 2.17.314-.01 2.691Zm4.469-4.115-.01 2.665-3.959 1.385.011-2.665 3.958-1.385Z"
    />
    <path
      fill="#F1F5F9"
      stroke="#101010"
      d="m325.315 311.934 3.577 2.075-7.126 16.833-.124.293.213.237 1.339 1.486-1.081 2.548-4.135 1.447-2.402-.346-2.332-2.246 1.076-2.538 2.552-1.021.193-.077.082-.192 7.6-17.959.001-.001c.074-.172.258-.365.567-.539Z"
    />
    <path
      fill="#101010"
      d="M327.095 296.399c1.143.662 1.143 1.735 0 2.384-1.143.662-2.981.662-4.124 0-1.142-.661-1.142-1.735 0-2.384 1.143-.661 2.981-.661 4.124 0Z"
    />
    <circle
      cx={18.102}
      cy={18.102}
      r={17.602}
      fill="#fff"
      fillOpacity={0.3}
      stroke="#101010"
      transform="matrix(.82535 .56461 -.90168 .4324 273.961 289.849)"
    />
    <path
      fill="url(#f)"
      stroke="#101010"
      d="M270.396 307.159v-1.445l5.856.032v1.443c-.009.265-.192.628-.757.961-.578.332-1.361.512-2.171.512-.811 0-1.595-.18-2.172-.513l-.004-.002c-.577-.327-.752-.708-.752-.988Z"
    />
    <path
      fill="#F7F5EB"
      stroke="#101010"
      d="M275.484 304.259c.579.334.756.704.756.971 0 .268-.177.637-.756.971-.577.333-1.362.514-2.172.514-.811 0-1.595-.181-2.173-.514-.579-.334-.756-.703-.756-.971 0-.267.177-.637.756-.971.578-.333 1.362-.513 2.173-.513.81 0 1.595.18 2.172.513Z"
    />
    <path
      fill="url(#g)"
      stroke="#101010"
      d="M272.52 304.914v-2.236h1.559v2.244l-.004.005a.41.41 0 0 1-.123.104 1.378 1.378 0 0 1-.653.145c-.264 0-.499-.058-.652-.145a.393.393 0 0 1-.12-.104l-.007-.013Z"
    />
    <path
      fill="#101010"
      d="M272.02 301.454v.987c0 .187.124.386.372.536.497.287 1.317.287 1.814 0 .248-.15.373-.337.373-.524v-.986h-2.572l.013-.013Z"
    />
    <path
      fill="#6B80D2"
      stroke="#101010"
      strokeWidth={0.4}
      d="M273.312 300.915c.303 0 .594.066.805.187.211.128.274.266.274.363 0 .097-.062.232-.273.353-.21.122-.502.189-.806.189-.304 0-.595-.067-.805-.188-.211-.128-.275-.265-.275-.363 0-.097.063-.231.273-.353.21-.121.503-.188.807-.188Z"
    />
    <circle
      cx={18.102}
      cy={18.102}
      r={17.602}
      fill="#fff"
      fillOpacity={0.3}
      stroke="#101010"
      transform="scale(1.22477 .70706) rotate(45 -300.83 505.061)"
    />
    <path
      fill="url(#h)"
      stroke="#101010"
      d="M326.553 274.203v-1.445l5.857.032v1.443c-.009.265-.192.628-.758.96-.577.333-1.36.513-2.17.513-.811 0-1.595-.181-2.173-.514l-.003-.002c-.577-.326-.753-.707-.753-.987Z"
    />
    <path
      fill="#F7F5EB"
      stroke="#101010"
      d="M331.641 271.303c.579.334.756.704.756.971 0 .268-.177.637-.756.971-.577.333-1.361.514-2.172.514-.81 0-1.595-.181-2.172-.514-.579-.334-.756-.703-.756-.971 0-.267.177-.637.756-.971.577-.333 1.362-.514 2.172-.514.811 0 1.595.181 2.172.514Z"
    />
    <path
      fill="url(#i)"
      stroke="#101010"
      d="M328.677 271.958v-2.236h1.559v2.244a.423.423 0 0 1-.127.108c-.153.088-.388.146-.652.146s-.499-.058-.653-.146a.386.386 0 0 1-.119-.103l-.008-.013Z"
    />
    <path
      fill="#101010"
      d="M328.177 268.498v.986c0 .188.125.387.373.537.497.287 1.317.287 1.814 0 .248-.15.372-.337.372-.524v-.986h-2.571l.012-.013Z"
    />
    <path
      fill="#6B80D2"
      stroke="#101010"
      strokeWidth={0.4}
      d="M329.469 267.959c.303 0 .595.066.805.187.211.128.275.266.275.363 0 .097-.063.231-.273.353-.211.121-.503.188-.807.188-.303 0-.595-.066-.805-.187-.211-.128-.274-.265-.274-.363 0-.097.062-.231.273-.353.21-.121.502-.188.806-.188Z"
    />
    <circle
      cx={18.102}
      cy={18.102}
      r={17.602}
      fill="#fff"
      fillOpacity={0.3}
      stroke="#101010"
      transform="matrix(.90205 .43163 -.82487 .56532 374.111 281.416)"
    />
    <path
      fill="url(#j)"
      stroke="#101010"
      d="M371.69 300.124v-1.445l5.856.032v1.443c-.009.265-.192.628-.757.961-.578.332-1.361.512-2.171.512-.811 0-1.595-.18-2.172-.513l-.004-.002c-.577-.327-.752-.708-.752-.988Z"
    />
    <path
      fill="#F7F5EB"
      stroke="#101010"
      d="M376.778 297.224c.579.334.756.704.756.971 0 .268-.177.637-.756.971-.577.333-1.362.514-2.172.514-.811 0-1.595-.181-2.173-.514-.579-.334-.756-.703-.756-.971 0-.267.177-.637.756-.971.578-.333 1.362-.513 2.173-.513.81 0 1.595.18 2.172.513Z"
    />
    <path
      fill="url(#k)"
      stroke="#101010"
      d="M373.814 297.879v-2.236h1.559v2.244l-.004.005a.41.41 0 0 1-.123.104 1.378 1.378 0 0 1-.653.146 1.37 1.37 0 0 1-.652-.146.393.393 0 0 1-.12-.104.057.057 0 0 1-.007-.013Z"
    />
    <path
      fill="#101010"
      d="M373.314 294.419v.987c0 .187.124.387.372.536.497.287 1.317.287 1.814 0 .248-.149.373-.337.373-.524v-.986h-2.572l.013-.013Z"
    />
    <path
      fill="#6B80D2"
      stroke="#101010"
      strokeWidth={0.4}
      d="M374.606 293.88c.303 0 .594.066.805.187.211.128.274.266.274.363 0 .097-.062.232-.273.353-.21.122-.502.189-.806.189-.304 0-.595-.067-.805-.188-.211-.128-.275-.265-.275-.363 0-.097.063-.231.273-.353.21-.121.503-.188.807-.188Z"
    />
    <circle
      cx={18.102}
      cy={18.102}
      r={17.602}
      fill="#fff"
      fillOpacity={0.3}
      stroke="#101010"
      transform="matrix(.83188 .55495 -.89658 .4429 316.842 317.497)"
    />
    <path
      fill="url(#l)"
      stroke="#101010"
      d="M315.033 332.903v-1.444l5.856.032v1.443c-.009.265-.192.627-.758.96-.577.332-1.36.513-2.17.513-.811 0-1.595-.181-2.172-.514l-.004-.002c-.577-.327-.752-.708-.752-.988Z"
    />
    <path
      fill="#F7F5EB"
      stroke="#101010"
      d="M320.121 330.004c.579.334.756.703.756.971 0 .267-.177.637-.756.971-.577.333-1.362.513-2.173.513-.81 0-1.595-.18-2.172-.513-.579-.334-.756-.704-.756-.971 0-.268.177-.637.756-.971.577-.333 1.362-.514 2.172-.514.811 0 1.596.181 2.173.514Z"
    />
    <path
      fill="url(#m)"
      stroke="#101010"
      d="M317.157 330.659v-2.236h1.558v2.244l-.003.004a.396.396 0 0 1-.123.104 1.378 1.378 0 0 1-.653.146 1.37 1.37 0 0 1-.652-.146.395.395 0 0 1-.12-.103.057.057 0 0 1-.007-.013Z"
    />
    <path
      fill="#101010"
      d="M316.657 327.199v.986c0 .187.124.387.372.537.497.287 1.317.287 1.814 0 .248-.15.372-.337.372-.524v-.987h-2.571l.013-.012Z"
    />
    <path
      fill="#6B80D2"
      stroke="#101010"
      strokeWidth={0.4}
      d="M317.948 326.659c.304 0 .595.067.806.188.21.128.274.265.274.363 0 .097-.063.231-.273.353-.21.121-.503.188-.807.188-.303 0-.594-.067-.805-.188-.21-.127-.274-.265-.274-.362 0-.097.062-.232.273-.353.21-.122.503-.189.806-.189Z"
    />
    <path
      fill="#101010"
      d="M319.159 291.466c1.143.661 1.143 1.735 0 2.384-1.143.661-2.981.661-4.124 0-1.143-.662-1.143-1.735 0-2.384 1.143-.662 2.981-.662 4.124 0Z"
    />
    <path
      fill="#F7F5EB"
      stroke="#101010"
      d="M316.319 281.887v9.81a.646.646 0 0 0 1.293 0v-13.511c0-.634-.818-.889-1.178-.367a.643.643 0 0 0-.115.367v3.701Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={340.659}
        x2={337.644}
        y1={313.5}
        y2={318.704}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#38302D" />
        <stop offset={0.07} stopColor="#352D2A" />
        <stop offset={0.6} stopColor="#241F1C" />
        <stop offset={1} stopColor="#1E1A18" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={339.549}
        x2={341.096}
        y1={315.215}
        y2={318.103}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B9B0BE" />
        <stop offset={1} stopColor="#9F95A1" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={339.422}
        x2={340.958}
        y1={315.286}
        y2={318.168}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B9B0BE" />
        <stop offset={1} stopColor="#9F95A1" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={339.651}
        x2={340.082}
        y1={316.86}
        y2={316.116}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#878787" />
        <stop offset={1} stopColor="#5B5B5B" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={269.896}
        x2={276.74}
        y1={307.184}
        y2={307.184}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CBC7C2" />
        <stop offset={1} stopColor="#E2DFD7" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={272.02}
        x2={274.603}
        y1={303.926}
        y2={303.926}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CBC7C2" />
        <stop offset={1} stopColor="#E2DFD7" />
      </linearGradient>
      <linearGradient
        id="h"
        x1={326.053}
        x2={332.897}
        y1={274.228}
        y2={274.228}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CBC7C2" />
        <stop offset={1} stopColor="#E2DFD7" />
      </linearGradient>
      <linearGradient
        id="i"
        x1={328.177}
        x2={330.761}
        y1={270.97}
        y2={270.97}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CBC7C2" />
        <stop offset={1} stopColor="#E2DFD7" />
      </linearGradient>
      <linearGradient
        id="j"
        x1={371.19}
        x2={378.034}
        y1={300.149}
        y2={300.149}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CBC7C2" />
        <stop offset={1} stopColor="#E2DFD7" />
      </linearGradient>
      <linearGradient
        id="k"
        x1={373.314}
        x2={375.897}
        y1={296.891}
        y2={296.891}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CBC7C2" />
        <stop offset={1} stopColor="#E2DFD7" />
      </linearGradient>
      <linearGradient
        id="l"
        x1={314.533}
        x2={321.377}
        y1={332.928}
        y2={332.928}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CBC7C2" />
        <stop offset={1} stopColor="#E2DFD7" />
      </linearGradient>
      <linearGradient
        id="m"
        x1={316.657}
        x2={319.24}
        y1={329.67}
        y2={329.67}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CBC7C2" />
        <stop offset={1} stopColor="#E2DFD7" />
      </linearGradient>
      <radialGradient
        id="b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(1.0558 -1.83767 1.83316 1.05321 339.727 316.328)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2A262C" />
        <stop offset={0.33} stopColor="#080509" />
        <stop offset={0.44} />
        <stop offset={0.63} />
        <stop offset={1} />
      </radialGradient>
    </defs>
  </svg>
);

export default DroneSvg;
